export const searchCAExpensePills = [
  { id: 1, title: "Customers", value: "950", variant: "dark" },
  { id: 1, title: "Total Marlay", value: "1,518", variant: "info" },
  { id: 1, title: "Price", value: "Rs 1,405,861,300", variant: "dark" },
  { id: 1, title: "Received", value: "Rs 221,331,860", variant: "info" },
  { id: 1, title: "Balance", value: "Rs 1,184,529,440", variant: "dark" },
  { id: 1, title: "Others", value: "Rs 61,100", variant: "info" },
  { id: 1, title: "Invoices", value: "6,022", variant: "dark" },
];

export const searchCAExpenseTableColumns = [
  { id: 1, name: "#" },
  { id: 2, name: "ID" },
  { id: 3, name: "Amount" },
  { id: 4, name: "Date" },
  { id: 6, name: "Description" },
  { id: 5, name: "Created By" },
  { id: 5, name: "Updated By" },
];
